const BASE_API_URL = 'https://supplychain.nutrifytoday.com';
// const BASE_API_URL = 'http://localhost:3335';
export default BASE_API_URL;